import type { QuickWritePrompt } from '@/types/quickWrite'

export const QUICK_WRITE_PROMPTS: QuickWritePrompt[] = [
  { id: 'door-unexpected', text: 'A door appears in your bedroom wall. You open it. What is on the other side?', tags: ['fantasy', 'opener'] },
  { id: 'strange-sound', text: 'Write about the strangest sound you have ever heard.', tags: ['memoir', 'sense'] },
  { id: 'found-key', text: 'A character finds a key. What does it unlock?', tags: ['mystery', 'object'] },
  { id: 'safe-place', text: 'Describe a place that feels safe.', tags: ['memoir', 'place'] },
  { id: 'pet-talks', text: 'A pet starts talking. What is the first thing it says?', tags: ['fantasy', 'character'] },
  { id: 'friends-arguing', text: 'Two friends are arguing. About what?', tags: ['conflict', 'dialogue'] },
  { id: 'missing-room', text: 'Write about a room that is missing something important.', tags: ['mystery', 'place'] },
  { id: 'unordered-package', text: 'A character receives a package they did not order. What is inside?', tags: ['mystery', 'object'] },
  { id: 'last-day-summer', text: 'It is the last day of summer. What happens?', tags: ['memoir', 'season'] },
  { id: 'taste-color', text: 'Write about a color you can taste.', tags: ['sense', 'creative'] },
  { id: 'hiding-from', text: 'A character is hiding from something. From what?', tags: ['conflict', 'tension'] },
  { id: 'meal-meaning', text: 'Describe a meal that means something.', tags: ['memoir', 'sense'] },
  { id: 'hard-choice', text: 'A character has to make a hard choice. What is it?', tags: ['conflict', 'character'] },
  { id: 'night-place', text: 'Write about a place that only exists at night.', tags: ['fantasy', 'place'] },
  { id: 'pocket-note', text: 'A character finds a note in their pocket. What does it say?', tags: ['mystery', 'object'] },
  { id: 'thoughts-minute', text: 'A character can hear what others are thinking, but only for one minute. Whose thoughts?', tags: ['fantasy', 'character'] },
  { id: 'memory-stays', text: 'Write about a memory that will not go away.', tags: ['memoir', 'emotion'] },
  { id: 'character-lost', text: 'A character is lost. Where? Why?', tags: ['conflict', 'place'] },
  { id: 'first-meet', text: 'Two characters meet for the first time. Where? Why?', tags: ['character', 'opener'] },
  { id: 'sound-home', text: 'Write about a sound that means home.', tags: ['sense', 'memoir'] },
]

export function getPromptById(id: string): QuickWritePrompt | undefined {
  return QUICK_WRITE_PROMPTS.find((p) => p.id === id)
}

export function getDailyPrompt(date: Date = new Date()): QuickWritePrompt {
  const dayIndex = Math.floor(date.getTime() / (1000 * 60 * 60 * 24))
  return QUICK_WRITE_PROMPTS[dayIndex % QUICK_WRITE_PROMPTS.length]
}

export function getRandomPrompt(excludeId?: string): QuickWritePrompt {
  const pool = excludeId
    ? QUICK_WRITE_PROMPTS.filter((p) => p.id !== excludeId)
    : QUICK_WRITE_PROMPTS
  const selected = pool[Math.floor(Math.random() * pool.length)]
  if (!selected) {
    throw new Error('Cannot pick random prompt from empty pool')
  }
  return selected
}
